export const GET_WEEKLY_STAR_SETTINGS = "GET_WEEKLY_STAR_SETTINGS";
export const UPDATE_WEEKLY_STAR_GIFTS = "UPDATE_WEEKLY_STAR_GIFTS";
export const UPDATE_WEEKLY_STAR_REWARDS = "UPDATE_WEEKLY_STAR_REWARDS";

export const OPEN_WEEKLY_STAR_REWARD_DIALOG = "OPEN_WEEKLY_STAR_REWARD_DIALOG";
export const CLOSE_WEEKLY_STAR_REWARD_DIALOG = "CLOSE_WEEKLY_STAR_REWARD_DIALOG";

export const CLOSE_WEEKLY_STAR_GIFT_DIALOG = "CLOSE_WEEKLY_STAR_GIFT_DIALOG";
export const OPEN_WEEKLY_STAR_GIFT_DIALOG = "OPEN_WEEKLY_STAR_GIFT_DIALOG";
